export const liveFeaturesLabelObj = {
  smartLive: 'SMLC',
  standAloneLive: 'SALC',
};

export const liveConnect = 'liveConnect';
export const liveZoomPercent = '87%';
export const TEMP_LINK = 'temperatureAndConsumptionLink';
